import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["view", "tab"]
  static values = {
    current: { type: String, default: "kanban" },
    storageKey: String
  }

  connect() {
    const preferredView = this.readPreferredView()
    if (preferredView) this.currentValue = preferredView

    this.showView(this.currentValue)
    this.updateTabs(this.currentValue)
  }

  switch(event) {
    const view = event.currentTarget.dataset.view
    if (!view || view === this.currentValue) return

    this.currentValue = view
    this.showView(view)
    this.updateTabs(view)
    this.persistPreferredView(view)
    this.dispatch("changed", { detail: { view } })
  }

  readPreferredView() {
    if (!this.hasStorageKeyValue) return null

    try {
      const view = window.localStorage.getItem(this.storageKeyValue)
      return this.viewTargets.some((target) => target.dataset.view === view) ? view : null
    } catch (_error) {
      return null
    }
  }

  persistPreferredView(view) {
    if (!this.hasStorageKeyValue) return

    try {
      window.localStorage.setItem(this.storageKeyValue, view)
    } catch (_error) {
      // Private browsing or a restrictive browser can disable local storage.
      // The board remains usable with the default Kanban view.
    }
  }

  showView(view) {
    this.viewTargets.forEach((el) => {
      const isActive = el.dataset.view === view
      el.classList.toggle("hidden", !isActive)
    })
  }

  updateTabs(view) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.view === view
      
      tab.classList.toggle("kanban-view-tab-active", isActive)
      tab.classList.toggle("bg-white", isActive)
      tab.classList.toggle("dark:bg-slate-800", isActive)
      tab.classList.toggle("text-slate-900", isActive)
      tab.classList.toggle("dark:text-white", isActive)
      tab.classList.toggle("shadow-sm", isActive)
      
      tab.classList.toggle("kanban-view-tab", !isActive)
      tab.classList.toggle("text-slate-500", !isActive)
      tab.classList.toggle("dark:text-slate-400", !isActive)
      
      tab.setAttribute("aria-selected", isActive.toString())
    })
  }
}
